import { cn } from "@/design-system/lib/utils";
import type { TaskAssigneeDto } from "@/api/workTasks";

interface Props {
  assignee: TaskAssigneeDto | null;
  /** Override the displayed text — defaults to "Unassigned" when null. */
  unassignedLabel?: string;
  showName?: boolean;
  className?: string;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function TaskAssigneeAvatar({
  assignee,
  unassignedLabel = "Unassigned",
  showName = true,
  className,
}: Props) {
  const name = assignee?.displayName ?? unassignedLabel;
  return (
    <span className={cn("inline-flex items-center gap-space-2", className)}>
      <span
        aria-hidden
        className={cn(
          "inline-flex items-center justify-center w-7 h-7 rounded-full",
          "font-display text-[10px] font-bold tracking-[0.08em]",
          assignee
            ? "bg-gold text-onyx"
            : "bg-white-warm text-gray-mid border border-border-light",
        )}
      >
        {assignee ? initials(name) : "—"}
      </span>
      {showName && (
        <span className="text-small text-onyx truncate">{name}</span>
      )}
    </span>
  );
}
